import ButtonExamine from './src/main'

ButtonExamine.install = function (Vue) {
    Vue.components(ButtonExamine.name, ButtonExamine)
}

export default ButtonExamine